// bolao-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    ". Vencedores = acertaram exatamente este placar.": ". Ganadores = acertaron exactamente este marcador.",
    "Agenda": "Agenda",
    "Aguardando processar": "Esperando procesar",
    "Antes de ativar, crie": "Antes de activar, cree",
    "Ao criar cada brinde no Clube de Vantagens, basta escolher este bolão pelo nome no formulário.": "Al crear cada premio en el Club de Beneficios, solo debe elegir esta quiniela por el nombre en el formulario.",
    "Aplicar Recompensas": "Aplicar Recompensas",
    "Ativar bolão": "Activar quiniela",
    "Avaliar (preview)": "Evaluar (vista previa)",
    "Banner": "Banner",
    "Banner (opcional)": "Banner (opcional)",
    "Bolão ativado!": "¡Quiniela activada!",
    "Bolão criado em rascunho. Configure os Gifts e ative quando estiver pronto.": "Quiniela creada en borrador. Configure los Gifts y actívela cuando esté lista.",
    "Bolão inativado. Ele some do aplicativo e para de dar direito a palpite.": "Quiniela inactivada. Desaparece de la aplicación y deja de dar derecho a pronóstico.",
    "Bolão reativado.": "Quiniela reactivada.",
    "Bolão:": "Quiniela:",
    "Bolões da Copa": "Quinielas de la Copa",
    "Buscar (nome, CPF, celular)": "Buscar (nombre, CPF, celular)",
    "Buscar nome": "Buscar nombre",
    "Cadastrar resultado": "Registrar resultado",
    "Clique para escolher uma imagem": "Haga clic para elegir una imagen",
    "Criar bolão": "Crear quiniela",
    "Criar brinde no Clube de Vantagens": "Crear premio en el Club de Beneficios",
    "Deadline palpite": "Plazo pronóstico",
    "Descrição (opcional)": "Descripción (opcional)",
    "Detalhes": "Detalles",
    "Deve ser igual ou anterior ao kickoff": "Debe ser igual o anterior al inicio del partido",
    "Esta ação entrega o": "Esta acción entrega el",
    "Estatísticas": "Estadísticas",
    "Este bolão está inativo: não aparece no aplicativo e não dá direito a palpite. Reative para voltar a exibi-lo": "Esta quiniela está inactiva: no aparece en la aplicación y no da derecho a pronóstico. Reactive para volver a mostrarla",
    "Este bolão já foi processado. Edição bloqueada — abra um chamado para suporte se for necessário corrigir.": "Esta quiniela ya fue procesada. Edición bloqueada — abra un ticket de soporte si necesita corregirla.",
    "Fechado": "Cerrado",
    "Ganhadores potenciais": "Ganadores potenciales",
    "Ganhou direito em": "Obtuvo el derecho el",
    "Imagem enviada.": "Imagen enviada.",
    "Imagem larga exibida no topo da tela do bolão no app. JPG/PNG/WebP até 5MB.": "Imagen ancha que se muestra en la parte superior de la pantalla de la quiniela en la aplicación. JPG/PNG/WebP hasta 5MB.",
    "Imagem larga exibida no topo. JPG/PNG/WebP até 5MB.": "Imagen ancha que se muestra en la parte superior. JPG/PNG/WebP hasta 5MB.",
    "Imagem maior que 5MB. Escolha um arquivo menor.": "Imagen mayor a 5MB. Elija un archivo más pequeño.",
    "Imagem quadrada (logo/escudo)": "Imagen cuadrada (logo/escudo)",
    "Inativar bolão": "Inactivar quiniela",
    "Inativar tira o bolão do aplicativo e para de dar direito a palpite em novos abastecimentos. Os palpites já registrados são mantidos. Você pode reativar depois.": "Inactivar retira la quiniela de la aplicación y deja de dar derecho a pronóstico en nuevas cargas de combustible. Los pronósticos ya registrados se mantienen. Puede reactivarla después.",
    "Inativo": "Inactivo",
    "Início do jogo": "Inicio del partido",
    "Limite palpite": "Límite pronóstico",
    "Limite para palpitar": "Límite para pronosticar",
    "Logo time da casa": "Logo equipo local",
    "Logo time da casa (opcional)": "Logo equipo local (opcional)",
    "Logo time visitante": "Logo equipo visitante",
    "Logo time visitante (opcional)": "Logo equipo visitante (opcional)",
    "Manual do Bolão": "Manual de la Quiniela",
    "Nenhum registro com esses filtros.": "Ningún registro con esos filtros.",
    "Nome do bolão": "Nombre de la quiniela",
    "Palpite": "Pronóstico",
    "Palpites": "Pronósticos",
    "Palpitou em": "Pronosticó el",
    "Partida": "Partido",
    "Placar oficial": "Marcador oficial",
    "Placar oficial cadastrado:": "Marcador oficial registrado:",
    "Processado": "Procesado",
    "Prêmio para Quem Acertar": "Premio para Quien Acierte",
    "Prêmio por Acerto": "Premio por Acierto",
    "Quadrado, fundo transparente": "Cuadrado, fondo transparente",
    "Rascunho": "Borrador",
    "Reativar bolão": "Reactivar quiniela",
    "Recarregar": "Recargar",
    "Recompensa de Palpite": "Recompensa de Pronóstico",
    "Recompensas": "Recompensas",
    "Remover imagem": "Quitar imagen",
    "Resultado cadastrado. Agora você pode avaliar e aplicar recompensas.": "Resultado registrado. Ahora puede evaluar y aplicar recompensas.",
    "Resultado oficial": "Resultado oficial",
    "Sem descrição": "Sin descripción",
    "Submetido em": "Enviado el",
    "Tickets": "Tickets",
    "Time da casa": "Equipo local",
    "Time visitante": "Equipo visitante",
    "Use para tirar do aplicativo um bolão já processado com resultado errado. O bolão some do app; os prêmios e cupons já entregues aos clientes são mantidos (não há estorno). Você pode reativar depois.": "Úselo para retirar de la aplicación una quiniela ya procesada con resultado incorrecto. La quiniela desaparece de la app; los premios y cupones ya entregados a los clientes se mantienen (no hay reversión). Puede reactivarla después.",
    "Vencedores": "Ganadores",
    "a todos os clientes que acertaram o placar exato e encerra o bolão. Não pode ser desfeita.": "a todos los clientes que acertaron el marcador exacto y cierra la quiniela. No se puede deshacer.",
    "achievements criados,": "achievements creados,",
    "clientes acertaram o placar exato.": "clientes acertaron el marcador exacto.",
    "cupons gerados.": "cupones generados.",
    "dois brindes": "dos premios",
    "erros — verificar logs": "errores — verificar logs",
    "no Clube de Vantagens, ambos vinculados a este bolão:": "en el Club de Beneficios, ambos vinculados a esta quiniela:",
    "— o cupom/desconto que os ganhadores vão receber depois que você processar o resultado.": "— el cupón/descuento que los ganadores recibirán después de que usted procese el resultado.",
    "— o que o cliente ganha por abastecer (vira o direito de palpitar neste bolão).": "— lo que el cliente gana por cargar combustible (se convierte en el derecho a pronosticar en esta quiniela).",
    "• página": "• página",
};

export default catalogo;
